import React, { useEffect, useState, useRef } from 'react';
import { useIntl, FormattedMessage } from 'react-intl';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { Modal } from 'react-bootstrap';
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
  ModalProgressBar,
} from '../../../../../../_metronic/_partials/controls';
import ChangedInfo from '../../../../../components/ChangedInfo';
import Activities from '../../../../../components/Activities';
import * as actions from '../../../_redux/products/productsActions';
import { initialProduct } from '../ProductsUIHelpers';
import ProductViewForm from './ProductViewForm';
import SubProducts from './SubProducts';

export function ProductViewDialog({
  history,
  match: {
    params: { id },
  },
}) {
  const intl = useIntl();
  const [tab, setTab] = useState('basic');
  const [title, setTitle] = useState('');
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const titleText = intl.formatMessage({ id: 'PRODUCT.TITLE.DETAIL' });
  //console.log('id=', id);

  const { actionsLoading, productForView, error, msg } = useSelector(
    (state) => ({
      actionsLoading: state.products.actionsLoading,
      productForView: state.products.productForView,
      error: state.products.error,
      msg: state.products.msg,
    }),
    shallowEqual
  );

  useEffect(() => {
    dispatch(actions.fetchProduct(id));
  }, [id, dispatch]);

  useEffect(() => {
    let _title = intl.formatMessage({ id: 'PRODUCT.QUICKACTIONS.TITLE' });
    if (productForView && id) {
      _title = `${titleText} #${productForView.id}`;
    }
    setTitle(_title);
  }, [productForView, id]);

  const onHide = () => {
    history.push(`/products`);
  };

  const saveProduct = (values) => {
    if (!loading) {
      setLoading(true);
      //console.log('saveProduct', values);
      if (!productForView) {
        dispatch(actions.createProduct(values));
      } else {
        dispatch(actions.updateProduct(values));
      }
      setLoading(false);
    }
  };

  const newClick = () => {
    dispatch(actions.clearProduct());
    history.push('/products/new');
  };
  const btnRefNew = useRef();
  const newProductClick = () => {
    //console.log('saveProductClick');
    if (btnRefNew && btnRefNew.current) {
      btnRefNew.current.click();
    }
  };
  const btnRefSave = useRef();
  const saveProductClick = () => {
    //console.log('saveProductClick');
    if (btnRefSave && btnRefSave.current) {
      btnRefSave.current.click();
    }
  };

  const backToList = () => {
    history.push(`/products`);
  };

  return (
    <>
      <Modal.Body className='overlay overlay-block cursor-default'>
        {actionsLoading && <ModalProgressBar />}
        {actionsLoading && (
          <div className='overlay-layer bg-transparent'>
            <div className='spinner spinner-lg spinner-success' />
          </div>
        )}
        <Card>
          {actionsLoading && <ModalProgressBar />}
          <CardHeader title={title}>
            <CardHeaderToolbar>
              <button
                type='button'
                onClick={backToList}
                className='btn btn-light btn-elevate'
              >
                <FormattedMessage id='GENERAL.BUTTON.CANCEL' />
              </button>
              <> </>
              <button
                type='button'
                className='btn btn-secondary ml-2'
                onClick={newProductClick}
                disabled={
                  productForView && productForView.productCode ? false : true
                }
              >
                <FormattedMessage id='GENERAL.BUTTON.NEW' />
                {loading && (
                  <span
                    id='productSaveLoading3'
                    className='ml-3 spinner spinner-white '
                  ></span>
                )}
              </button>
              <> </>
              {tab === 'basic' && (
                <button
                  type='submit'
                  className='btn btn-primary ml-2'
                  onClick={saveProductClick}
                >
                  <FormattedMessage id='GENERAL.BUTTON.SAVE' />
                  {loading && (
                    <span
                      id='productSaveLoading2'
                      className='ml-3 spinner spinner-white '
                    ></span>
                  )}
                </button>
              )}
            </CardHeaderToolbar>
          </CardHeader>
          <CardBody>
            <ul className='nav nav-tabs nav-tabs-line ' role='tablist'>
              <li className='nav-item' onClick={() => setTab('basic')}>
                <a
                  className={`nav-link ${tab === 'basic' && 'active'}`}
                  data-toggle='tab'
                  role='tab'
                  aria-selected={(tab === 'basic').toString()}
                >
                  Бүртгэл
                </a>
              </li>
              <li className='nav-item' onClick={() => setTab('subProducts')}>
                <a
                  className={`nav-link ${tab === 'subProducts' && 'active'}`}
                  data-toggle='tab'
                  role='tab'
                  aria-selected={(tab === 'subProducts').toString()}
                >
                  Дэд бүтээгдэхүүн{' '}
                  {productForView && productForView.subProduct > 0
                    ? ' - ' + productForView.subProduct
                    : ''}
                </a>
              </li>
              <li className='nav-item' onClick={() => setTab('activity')}>
                <a
                  className={`nav-link ${tab === 'activity' && 'active'}`}
                  data-toggle='tab'
                  role='button'
                  aria-selected={(tab === 'activity').toString()}
                >
                  Өөрчлөлтийн түүх
                </a>
              </li>
            </ul>
            <div className='mt-5'>
              {tab === 'basic' && (
                <>
                  <ProductViewForm
                    actionsLoading={actionsLoading}
                    productForView={productForView || initialProduct}
                    initialProduct={initialProduct}
                    btnRefSave={btnRefSave}
                    btnRefNew={btnRefNew}
                    saveProduct={saveProduct}
                    newClick={newClick}
                    onHide={onHide}
                    error={error}
                    info={msg}
                  />
                </>
              )}
              {tab === 'subProducts' && (
                <>
                  {productForView && <SubProducts product={productForView} />}
                </>
              )}
              {tab === 'activity' && id && (
                <Activities productCode={productForView.id} />
              )}
            </div>
          </CardBody>
        </Card>
      </Modal.Body>
      <Modal.Footer>
        {productForView && (
          <ChangedInfo
            value={{
              createdByName: productForView.createdByName,
              createdAt: productForView.createdAt,
              updatedByName: productForView.createdByName,
              updatedAt: productForView.updatedAt,
            }}
          />
        )}
      </Modal.Footer>
    </>
  );
}
